import { forwardRef } from "react";
import Input, { InputProps } from "../Input/Input";

interface NumberInputProps extends Omit<InputProps, "onChange" | "value"> {
  value?: number | null;
  onChange?: (value: number | null) => void;
}

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ value, onChange, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        {...props}
        type="number"
        allowClear
        value={value ?? ""}
        onChange={(value) => {
          if (onChange) {
            onChange(value !== "" ? Number(value) : null);
          }
        }}
      />
    );
  },
);

export default NumberInput;
